import React from 'react';
import { Spinner } from 'react-bootstrap';
import PropTypes from 'prop-types';
import './LoadingSpinner.css';

/**
 * LoadingSpinner Component
 * Standardized loading spinner used across the application
 * Matches the style from CoursesPage
 * @param {Object} props
 * @param {string} props.message - Optional message to display below spinner
 * @param {string} props.size - Spinner size: 'sm', 'md', 'lg'
 * @param {string} props.variant - Bootstrap variant (default: 'border')
 * @param {string} props.className - Additional CSS classes
 * @param {boolean} props.fullHeight - Whether to use full viewport height
 */
const LoadingSpinner = ({
  message,
  size = 'md',
  variant = 'border',
  className = '',
  fullHeight = false,
}) => {
  const sizeClass = size === 'sm' ? 'spinner-border-sm' : '';
  const containerClass = fullHeight ? 'loading-container-full' : 'loading-container';

  return (
    <div className={`${containerClass} ${className}`}>
      <div className="loading-content">
        <Spinner animation={variant} role="status" className={sizeClass}>
          <span className="visually-hidden">{message || 'Loading...'}</span>
        </Spinner>
        {message && <p className="loading-message">{message}</p>}
      </div>
    </div>
  );
};

LoadingSpinner.propTypes = {
  message: PropTypes.string,
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  variant: PropTypes.oneOf(['border', 'grow']),
  className: PropTypes.string,
  fullHeight: PropTypes.bool,
};

export default LoadingSpinner;
